module.exports = __webpack_public_path__ + "img/ruban_1.2094b6da.png";